import type { RcsListComposerState } from 'Pages/RcsList/types'
import { atom } from 'recoil'

export const composerState = atom<RcsListComposerState>({
  key: 'RcsListcomposerState',
  default: {
    token: '',
    dynamicFields: [],
    senderPhoneNumbers: [],
    senderAlias: [],
  },
})
